import React from "react";
import "../scss/Scss/Header.scss";
import logo from "../scss/Icon/CrimsonLogo.png";
import Hamberger from "../HomePage/menu";
import { NavLink } from "react-router-dom";
function MainMenu() {
  return (
    <>
      <div className="Header">
        <div className="class-logo">
          <NavLink exact to="/" activeClassName="activeLink">
            <img src={logo} className="Logo" alt="logo" loading="lazy" />
          </NavLink>
        </div>
        <div className="Menu">
          <Hamberger />
        </div>
      </div>
    </>
  );
}

export default MainMenu;
